import { useState, useEffect } from 'react';

/** Single source of truth for layout breakpoints (px).
 *  Mirrors --breakpoint-* in styles/designSystem.css. */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
} as const;

export type BreakpointKey = keyof typeof BREAKPOINTS;

/** True while viewport width is below the named breakpoint. Re-renders on resize. */
export const useBreakpointDown = (key: BreakpointKey): boolean => {
  const [down, setDown] = useState(window.innerWidth < BREAKPOINTS[key]);
  useEffect(() => {
    const onResize = () => setDown(window.innerWidth < BREAKPOINTS[key]);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [key]);
  return down;
};
